// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/popup","underlayVisible":"popup-m__underlayVisible__1Ztc-"};